module.exports = {"TXTACL_Close":{"id":"TXTACL_Close","defaultMessage":"Beenden","flags":["TRACK"],"track":"Close"}}